export default function LoadingBSZ() {
  return <div>Loading BSZ...</div>;
}
